import React from 'react';
import withIcon from '../utilities/withIcon';

const IconCopyright = () => {
  return (
    <g>
      <path d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0zm0 1.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13zm0 2.25c.868 0 1.698.261 2.4.742a4.27 4.27 0 0 1 1.082 1.07.75.75 0 0 1-1.228.862 2.77 2.77 0 0 0-.702-.695 2.75 2.75 0 1 0 .818 3.667.75.75 0 1 1 1.292.763A4.254 4.254 0 0 1 8 12.25a4.25 4.25 0 1 1 0-8.5z" />
    </g>
  );
};

export default withIcon(IconCopyright);
